//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListSkeleton from '@/components/Skeletons/ListSkeleton'
import Tag from '@/api/promotores/tags.api'

export default {
  components: { ListSkeleton },

  props: {
    selected: {
      type: Array,
      default: [],
    }
  },

  data() {
    return {
      tags: [],
      selected_: this.selected.map(tag => tag.id),
      loading: false,
      updating: false
    }
  },

  mounted() {
    this.loadTags()
  },

  methods: {
    show() {
      this.$refs.dialog.show()
    },

    hide() {
      this.$refs.dialog.hide()
    },

    async loadTags() {
      try {
        this.loading = true
        const tags = await Tag.all()
        this.tags = tags.filter(tag => tag.slug !== 'tareas-cierralo-tu')
      } finally {
        this.loading = false
      }
    },

    submit() {
      const selected = this.tags.filter((tag) => this.selected_.includes(tag.id))
      
      this.$emit('ok', selected)
    }
  }
}
